import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { ActiveCartFacade, OrderEntry } from '@spartacus/cart/base/root';
import { RoutingService } from '@spartacus/core';
import { filter, Observable } from 'rxjs';

@Component({
  selector: 'knbr-sales-cart-empty',
  imports: [AsyncPipe],
  templateUrl: './sales-cart-empty.component.html',
  styleUrl: './sales-cart-empty.component.scss',
})
export class SalesCartEmptyComponent {

  entries$: Observable<OrderEntry[]>;
  constructor(protected activeCartService: ActiveCartFacade, protected routingService: RoutingService) { }
  ngOnInit() {
    this.entries$ = this.activeCartService
      .getEntries()
      .pipe(filter((entries) => entries.length >= 0));
    this.entries$.subscribe((entries) => {
    });

  }

  navigate() {
    this.routingService.goByUrl('/search/active-brands');
  }
}
